import * as localStorage from "../utils/localStorage"
import refreshTokenApi from "./refreshTokenApi"
import { auth } from "../firebase"
import firebaseLogin from "./firebaseLogin"

export default async () => {
  try {
    // First, try to use the refresh_token if available
    const refreshToken = localStorage.get("refresh_token")

    if (refreshToken) {
      try {
        const response = await refreshTokenApi(refreshToken)

        return {
          data: {
            token: response.token,
            refresh_token: response.refresh_token,
          },
        }
      } catch (refreshError) {
        console.error("Failed to refresh token with refresh_token:", refreshError)
        // If refresh token fails, fall back to Firebase token
      }
    }

    // If no refresh_token or refresh failed, use Firebase token
    const currentUser = auth.currentUser
    if (currentUser) {
      const firebaseToken = await currentUser.getIdToken(true)

      // Call the firebase-login API to get new tokens
      try {
        const loginResponse = await firebaseLogin(firebaseToken)

        // Return in the same format as the original API response
        return {
          data: {
            token: loginResponse.token,
            refresh_token: loginResponse.refresh_token,
          },
        }
      } catch (loginError) {
        console.error("Failed to get new tokens from firebase-login:", loginError)
        throw loginError
      }
    }

    throw new Error("No user is signed in and no refresh token available")
  } catch (error) {
    console.error("Failed to refresh token:", error)
    throw error
  }
}
